import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import styles from './custom_modal.module.css'
import LoginCustomInput from '../../components/login/LoginCustomInput'
import strings from '../../strings/strings.json'
import Progress from '../progress/progress'

let emailTypingTimer = null
const defaultColor = "#07465d"
const emailRegex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const useStyles = makeStyles((theme) => ({
    paper: {
        position: "absolute",
        width: 400,
        backgroundColor: "#ffffff",
        border: 0,
        boxShadow: "0 10px 80px 2px rgba(77, 72, 103, 0.15)",
        padding: theme.spacing(2, 4, 3),
        left: "50%",
        top: "50%",
        outline: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "15px",
        [theme.breakpoints.down('xs')]: {
            width: 280,
            padding:10
        },
    },
}))

export default function CustomModal(props) {
    const classes = useStyles()
    const [emailValue, setEmailValue] = useState()
    const [emailHelperText, setEmailHelperText] = useState('')
    const [isEmailValid, setIsEmailValid] = useState(false)

    const emailOnChangeHandler = (e) => {
        const mail = e.target.value.trim()
        clearTimeout(emailTypingTimer)
        emailTypingTimer = setTimeout(() => {
            if (mail.length === 0) {
                setEmailHelperText('')
                setEmailValue(null)
                setIsEmailValid(false)
            }
            else if (emailRegex.test(mail)) {
                setEmailHelperText('')
                setEmailValue(mail)
                setIsEmailValid(true)
            } else {
                setEmailHelperText(strings.login_emailError)
                setIsEmailValid(false)
            }
        }, 500)

    }

    const ConfirmHandler = () => {

        if (emailValue && isEmailValid)
            props.confirmClicked(emailValue)
    }

    const cancelHandler = () => {

        props.ModalStateHandler(false)

    }

    return (
        <Modal
        disableScrollLock={true}
            open={props.openModal}
            onClose={props.closeModal}
        >
            <div className={classes.paper}>
                <div className={styles.container}>
                    <span className={styles.title}>{props.title}</span>
                    <span className={styles.subTitle}>{props.subTitle}</span>
                    <div className={styles.input_container}>
                        <LoginCustomInput
                            onChange={emailOnChangeHandler}
                            icon="email"
                            color={!emailHelperText ? defaultColor : "red"}
                            placeholder={strings.general_email}
                            type="text"
                            enterPressed={ev => ev.key === "Enter" && ConfirmHandler()}
                        />
                        <div style={!emailHelperText ? { visibility: "hidden" } : { visibility: "visible" }} className={styles.inputError_container}>
                            <span>{emailHelperText}</span>
                        </div>
                    </div>
                    {
                        props.isModalLoading ?
                            <div className={styles.progress_container}>
                                <Progress />
                            </div>
                            :
                            <div className={styles.btn_container}>
                                <button className={`${styles.confirm_btn} ${styles.btn_style}`} onClick={() => ConfirmHandler()}>{strings.general_confirm}</button>
                                <button className={`${styles.cancel_btn} ${styles.btn_style}`} onClick={() => cancelHandler()}>{strings.general_cancel}</button>
                            </div>
                    }
                </div>
            </div>
        </Modal>
    )
}